export { MediaSchema, type Media } from './media';
